export class DropboxSelection {

    public status!: string;
    public file?: Dropbox.ChooserFile;

    // tslint:disable-next-line: member-ordering
    public static success(file: Dropbox.ChooserFile): DropboxSelection {
        // tslint:disable-next-line: object-literal-shorthand
        return { status: 'success', file: file };
    }
    // tslint:disable-next-line: member-ordering
    public static cancel(): DropboxSelection {
        return { status: 'cancel'};
    }
}
